import React, { Component } from 'react';
import Repository from '../shared/repository';
import constraints from '../../../config/constants.json';

const contractId=constraints.contractId

class OnsiteRepository extends Component {
    constructor() {
        super();
        this.state = {}
    }

    render() {
        return (
            <Repository
                contractId={ContractId.ONSITE}
            />
        );
    }
}

export default OnsiteRepository;